import { useState, useMemo } from "react";

export const useStaffFilters = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedAccountCategory, setSelectedAccountCategory] = useState(null);
  const [showFilters, setShowFilters] = useState(false);

  const filterObject = useMemo(() => {
    const filter = {};
    if (selectedAccountCategory) filter.account_category_key = selectedAccountCategory;
    return filter;
  }, [selectedAccountCategory]);

  const activeFiltersCount = [
    selectedAccountCategory,
  ].filter(Boolean).length;

  const hasActiveFilters = searchQuery || selectedAccountCategory;

  const clearFilters = () => {
    setSearchQuery("");
    setSelectedAccountCategory(null);
  };

  const removeFilter = (filterType) => {
    if (filterType === 'account_category') setSelectedAccountCategory(null);
  };

  return {
    searchQuery,
    setSearchQuery,
    selectedAccountCategory,
    setSelectedAccountCategory,
    showFilters,
    setShowFilters,
    filterObject,
    activeFiltersCount,
    hasActiveFilters,
    clearFilters,
    removeFilter,
  };
};

